import { Stack, styled, Tooltip, Typography } from '@mui/material'
import isNil from 'lodash/isNil'
import { ComponentProps } from 'react'
import { Price } from '@omnea-app/packages/universal/price/price'
import { usePriceFormatter } from './usePriceFormatter'

export type PriceDisplayProps = {
  price: Price
  direction?: ComponentProps<typeof Stack>['direction']
  hideDefaultPrice?: boolean
  hideFrequency?: boolean
  variant?: ComponentProps<typeof Typography>['variant']
  tooltip?: boolean
}

export function PriceDisplay({
  price,
  direction = 'row',
  hideDefaultPrice = false,
  variant,
  hideFrequency,
  tooltip = false,
}: PriceDisplayProps) {
  const { formatPrice, defaultCurrency } = usePriceFormatter({ hideFrequency })
  const { formattedPrice, formattedDefaultPrice } = formatPrice(price)

  const shouldDisplayDefaultPrice = !isNil(formattedDefaultPrice) && !hideDefaultPrice && price.currency !== defaultCurrency

  return (
    <Stack direction={direction} spacing={1}>
      <Tooltip title={tooltip ? formattedPrice : ''}>
        <Typography variant={variant}>
          {formattedPrice}
          {direction === 'row' && shouldDisplayDefaultPrice && (
            <InlineDefaultPrice>{` (${formattedDefaultPrice})`}</InlineDefaultPrice>
          )}
        </Typography>
      </Tooltip>
      {direction === 'column' && shouldDisplayDefaultPrice && (
        <Tooltip title={tooltip ? formattedDefaultPrice : ''}>
          <Typography color="text.muted" variant="small-regular">
            {formattedDefaultPrice}
          </Typography>
        </Tooltip>
      )}
    </Stack>
  )
}

const InlineDefaultPrice = styled('span')(({ theme }) => ({
  color: theme.palette.text.muted,
}))
